import calculateSplat from './calculateSplat';

const calculateSplatForPencil = (pressure, pressureCoefficient, properties, settings) => {
  let splatProperties;

  if (settings.useAsBrush) {
    splatProperties = calculateSplat(pressure, pressureCoefficient, properties, settings.secondary);
  } else {
    splatProperties = calculateSplat(pressure, pressureCoefficient, properties, settings.primary);
  }

  // RECALCULATE COLOR
  const color = [...splatProperties.color];

  if (settings.useAsPencil) {
    color[2] = 1.0;
  }

  if (settings.useAsBrush) {
    color[2] = 0.0;
  }

  return {
    ...splatProperties,
    color,
  };
};

export default calculateSplatForPencil;
